import { InfoIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from 'src/components/ui/alert';

import { useUsers } from '../model';

const InvitationConfirmed = () => {
  const {
    ui: { closeDialog },
  } = useUsers();

  return (
    <div className="space-y-4">
      <Alert className="bg-accent border-card-foreground has-[>svg]:gap-x-1.5">
        <InfoIcon />
        <AlertDescription className="text-xs">
          This member won&apos;t have access to any products until you add them. Go to each product to assign access.
        </AlertDescription>
      </Alert>
      <Button onClick={closeDialog} variant="secondary" className="w-full">
        Back to organization
      </Button>
    </div>
  );
};

export default InvitationConfirmed;
